import { createSlice } from '@reduxjs/toolkit'
import { createNewWord, deleteWord, fetchWords, updateWord } from './extraReducers'
import WordUtils from '../../components/utils/WordUtils'

const slice = createSlice({
    name: 'words',
    initialState: {
        data: [] as any[],
        isLoading: false,
        isLoaded: false
    },
    reducers: {
        setWordsRoutine: (state, action) => {
            state.data = action.payload
        },
        clearWordsRoutine: (state) => {
            state.data = []
        },
        clearNotSavedWordsRoutine: (state) => {
            state.data = WordUtils.clearNotSavedWords(state.data)
        },
        setWordsLoadingRoutine: (state, action) => {
            state.isLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWords.fulfilled, (state, action) => {
                const words = WordUtils.mergeWords(state.data, WordUtils.parseWorlds(action.payload))
                state.data = WordUtils.removeDuplicates(words)
                state.isLoading = false
                state.isLoaded = true
            })
            .addCase(fetchWords.pending, (state) => {
                state.isLoading = true
                state.isLoaded = false
            })
            .addCase(fetchWords.rejected, (state) => {
                state.isLoading = false
                state.isLoaded = true
            })
            .addCase(createNewWord.fulfilled, (state, action) => {
                const { word, wordId } = action.payload as any
                state.data = state.data.map((w: any) => {
                    if (w.id === wordId) {
                        return WordUtils.parseWorld(word)
                    }
                    return w
                })
                state.isLoading = false
                state.isLoaded = true
            })
            .addCase(createNewWord.pending, (state, { meta }) => {
                const wordId = (meta.arg as any).word.id
                state.data = state.data.map((w: any) => {
                    return w.id === wordId ? WordUtils.loadWord(w, true) : w
                })
                state.isLoaded = false
            })
            .addCase(createNewWord.rejected, (state, { meta }) => {
                const wordId = (meta.arg as any).word.id
                state.data = state.data.map((w: any) => {
                    return w.id === wordId ? WordUtils.loadWord(w, false) : w
                })
                state.isLoaded = true
                WordUtils.wordErrorMsg('Не удалось сохранить карточку')
            })
            .addCase(updateWord.fulfilled, (state, action) => {
                const { word } = action.payload as any
                state.data = state.data.map((w: any) => {
                    if (w.id === word.id) {
                        return WordUtils.parseWorld(word)
                    }
                    return w
                })
                state.isLoading = false
                state.isLoaded = true
            })
            .addCase(updateWord.pending, (state, { meta }) => {
                const wordId = (meta.arg as any).word.id
                state.data = state.data.map((w: any) => {
                    return w.id === wordId ? WordUtils.loadWord(w, true) : w
                })
                state.isLoaded = false
            })
            .addCase(updateWord.rejected, (state, { meta }) => {
                const wordId = (meta.arg as any).word.id
                state.data = state.data.map((w: any) => {
                    return w.id === wordId ? WordUtils.loadWord(w, false) : w
                })
                state.isLoaded = true
                WordUtils.wordErrorMsg('Не удалось обновить карточку')
            })
            .addCase(deleteWord.fulfilled, (state, action) => {
                const wordId = (action.payload as any).wordId
                state.data = state.data.filter((w: any) => w.id !== wordId)
                state.isLoaded = true
            })
            .addCase(deleteWord.pending, (state, { meta }) => {
                const wordId = (meta.arg as any).wordId
                state.data = state.data.map((w: any) => {
                    return w.id === wordId ? WordUtils.loadWord(w, true) : w
                })
            })
            .addCase(deleteWord.rejected, (state, { meta }) => {
                const wordId = (meta.arg as any).wordId
                state.data = state.data.map((w: any) => {
                    return w.id === wordId ? WordUtils.loadWord(w, false) : w
                })
                state.isLoaded = true
                WordUtils.wordErrorMsg('Не удалось удалить карточку')
            })
    }
})

export const { setWordsRoutine, clearWordsRoutine, setWordsLoadingRoutine, clearNotSavedWordsRoutine } = slice.actions
export const wordsDataSelector = (state: any) => state.words.data
export const wordsIsisLoadingStatusSelector = (state: any) => state.words.isLoading
export default slice.reducer
